import axios from 'axios';
import { createAsyncThunk, createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { PaymentRequest } from '../../shared/model/facture.model';
import { serializeAxiosError } from 'app/shared/reducers/reducer.utils';
import { getFacture } from '../factures/facture.reducer';

const initialState = {
  loading: false,
  errorMessage: '',
  checkoutResponse: null,
};

const apiUrl = 'api/payments';

const getPaymentUrl = (method: string) => `/${apiUrl}/${method.toLowerCase()}`;

export const solder = createAsyncThunk(
  'payment/solder',
  async (payload: PaymentRequest, thunkAPI) => {
    const requestUrl = getPaymentUrl(payload.moyenPaiement);
    const data = {
      phoneNumber: payload.phoneNumber,
      factureId: payload.factureId,
      moyenPaiement: payload.moyenPaiement,
    };

    const response = await axios.post(requestUrl, data);
    thunkAPI.dispatch(getFacture(payload.factureId));
    return response;
  },
  { serializeError: serializeAxiosError }
);

// Création du slice Redux
const PaymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    reset() {
      return initialState;
    },
  },
  extraReducers(builder) {
    builder
      .addMatcher(isFulfilled(solder), (state, action) => {
        state.loading = false;
        state.checkoutResponse = action.payload.data;
      })
      .addMatcher(isRejected(solder), (state, action) => {
        state.loading = false;
        state.errorMessage = action.error.message;
      })
      .addMatcher(isPending(solder), state => {
        state.loading = true;
      });
  },
});

export const { reset } = PaymentSlice.actions;

export default PaymentSlice.reducer;
